import { contentScoreCutoffs } from '@/util/goal_scores'

export const ACCESS_LEVELS = ['trial', 'invite', 'premium'] as const
export type AccessLevel = typeof ACCESS_LEVELS[number]

export const ACCESS_SCORE_BOUNDS: Record<AccessLevel, { min: number, max: number }> = {
  premium: { min: contentScoreCutoffs.anchorMin, max: contentScoreCutoffs.anchorUnlockableMin - 0.001 },
  invite: { min: contentScoreCutoffs.anchorUnlockableMin, max: contentScoreCutoffs.anchorTrialMin - 0.001 },
  trial: { min: contentScoreCutoffs.anchorTrialMin, max: contentScoreCutoffs.anchorMax }
}

export function accessLevelFromScore(score: number | null): AccessLevel | '' {
  if (score === null) return ''
  return ACCESS_LEVELS.find(level => score >= ACCESS_SCORE_BOUNDS[level].min && score <= ACCESS_SCORE_BOUNDS[level].max) ?? ''
}

export function isScoreInBounds(level: AccessLevel | '', score: number | null): boolean {
  if (!level) return true
  return score !== null && score >= ACCESS_SCORE_BOUNDS[level].min && score <= ACCESS_SCORE_BOUNDS[level].max
}

export function scoreForLevel(level: AccessLevel, score: number | null): number {
  const { min, max } = ACCESS_SCORE_BOUNDS[level]
  const current = score ?? 0
  let adjustment = min - Math.floor(current)
  // The production team asked for new premium pages to start mid-band; toFixed trims float noise.
  if (level === 'premium' && !score) {
    adjustment += parseFloat(((max - min) / 2.0).toFixed(1))
  }
  return current + adjustment
}
